// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker {
  border: none;
  border-radius: 16px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
  font-family: inherit;
  background: #ffffff;
  overflow: hidden;
  transform: scale(1);
  transition: all 0.3s ease;
}

.react-datepicker__header {
  background: #172228;
  border-bottom: none;
  border-radius: 16px 16px 0 0;
  padding: 20px 16px 16px;
  position: relative;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #ffffff;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 12px;
  text-align: center;
  letter-spacing: 0.5px;
}

.react-datepicker__navigation {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 36px;
  height: 36px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.react-datepicker__navigation:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.react-datepicker__navigation--previous {
  left: 20px;
  top: 20px;
}

.react-datepicker__navigation--next {
  right: 20px;
  top: 20px;
}

.react-datepicker__navigation-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 8px;
}

.react-datepicker__navigation-icon::before {
  border-color: #ffffff;
  border-width: 2px 2px 0 0;
  width: 8px;
  height: 8px;
  position: absolute;
  top: calc(50% - 1px);
  left: calc(50% - 1px);
  transform: translate(-50%, -50%);
}

.react-datepicker__navigation--previous .react-datepicker__navigation-icon::before {
  transform: translate(-50%, -50%) rotate(-135deg);
  left: calc(50% + 1px);
}

.react-datepicker__navigation--next .react-datepicker__navigation-icon::before {
  transform: translate(-50%, -50%) rotate(45deg);
  left: calc(50% - 1px);
}

.react-datepicker__day-names {
  background: #172228;
  margin: 0;
  padding: 8px 0 0;
}

.react-datepicker__day-name {
  color: #ffffff;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 2.5rem;
  line-height: 1.2;
}

.react-datepicker__month {
  margin: 0;
  padding: 16px;
  background: #ffffff;
}

.react-datepicker__week {
  display: flex;
  justify-content: space-around;
  margin-bottom: 4px;
}

.react-datepicker__day {
  color: #495057;
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  margin: 2px;
  border-radius: 50%;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  font-size: 14px;
  position: relative;
  border: 2px solid transparent;
}

.react-datepicker__day:hover {
  background: #172228;
  color: #ffffff;
  transform: scale(1.15);
  box-shadow: 0 8px 25px rgba(23, 34, 40, 0.3);
  border-color: rgba(255, 255, 255, 0.2);
}

.react-datepicker__day--selected {
  background: #172228;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(23, 34, 40, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.react-datepicker__day--today {
  background: #d8b8a1;
  color: #000000;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(216, 184, 161, 0.4);
  border: 2px solid #fff;
}

.react-datepicker__day--today:hover {
  background: #d8b8a1;
  color: #000000;
  transform: scale(1.15);
  box-shadow: 0 8px 25px rgba(216, 184, 161, 0.5);
}

.react-datepicker__day--keyboard-selected {
  background: transparent;
  color: #495057;
  border: 2px solid transparent;
}

.react-datepicker__day--keyboard-selected:hover {
  background: #172228;
  color: #ffffff;
}

.react-datepicker__day--outside-month {
  color: #ced4da;
  opacity: 0.5;
}

.react-datepicker__day--disabled {
  color: #ced4da;
  cursor: not-allowed;
  opacity: 0.3;
}

.react-datepicker__day--disabled:hover {
  background: transparent;
  transform: none;
  box-shadow: none;
}

.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 6px;
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  color: #495057;
}

.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  background: #172228;
  color: #ffffff;
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(23, 34, 40, 0.3);
}

.react-datepicker__month-text--selected,
.react-datepicker__quarter-text--selected,
.react-datepicker__year-text--selected {
  background: #172228;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(23, 34, 40, 0.4);
}

.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background: transparent;
  color: #495057;
}

.react-datepicker__month-text--keyboard-selected:hover,
.react-datepicker__quarter-text--keyboard-selected:hover,
.react-datepicker__year-text--keyboard-selected:hover {
  background: #172228;
  color: #ffffff;
}

.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  background: #d8b8a1;
  color: #000000;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(216, 184, 161, 0.4);
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  padding: 14px;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown {
  background: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  max-height: 280px;
  min-width: 150px;
  overflow-y: auto;
  z-index: 1000;
}

.react-datepicker__year-option,
.react-datepicker__month-option {
  padding: 14px 24px;
  transition: all 0.3s ease;
  cursor: pointer;
  color: #495057;
  font-weight: 500;
  font-size: 15px;
  border-radius: 8px;
  margin: 3px 8px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover {
  background: #172228;
  color: #ffffff;
  transform: translateX(4px);
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected {
  background: #172228;
  color: #ffffff;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(23, 34, 40, 0.3);
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select {
  width: auto;
  min-width: 120px;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view {
  padding: 10px 16px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow {
  border-top-color: #ffffff;
  margin-left: 8px;
}

.react-datepicker__month-select,
.react-datepicker__year-select {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  padding: 8px 12px;
  min-width: 100px;
  margin: 0 4px;
}

.react-datepicker__month-select:focus,
.react-datepicker__year-select:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

.react-datepicker__month-select option,
.react-datepicker__year-select option {
  background: #172228;
  color: #ffffff;
  padding: 8px;
}

.react-datepicker__close-icon {
  background: #172228;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker__close-icon:hover {
  background: #dc3545;
  opacity: 1;
  transform: translateY(-50%);
}

.react-datepicker__close-icon::after {
  content: "×";
  background: transparent;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.react-datepicker {
  animation: slideInUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.react-datepicker__triangle {
  fill: #172228;
  color: #172228;
}

/* Configurações para time picker */
.time-picker-popper {
  z-index: 1060 !important;
}

.time-picker-popper .react-datepicker {
  z-index: 1060 !important;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  font-family: inherit;
  background: #ffffff;
  overflow: hidden;
}

/* Time picker specific styles */
.react-datepicker--time-only {
  width: 120px !important;
  max-width: 120px !important;
  min-width: 120px !important;
}

.react-datepicker--time-only .react-datepicker__header {
  background: #172228;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  padding: 12px;
  text-align: center;
}

.react-datepicker--time-only .react-datepicker__current-month {
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  margin: 0;
}

.react-datepicker__time-container {
  border: none;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
}

.react-datepicker__time {
  position: relative;
  background: white;
  border-radius: 0 0 8px 8px;
}

.react-datepicker__time-box {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  text-align: center;
}

.react-datepicker__time-list {
  height: 180px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  width: 100%;
  list-style: none;
}

.react-datepicker__time-list-item {
  height: auto;
  padding: 8px 12px;
  white-space: nowrap;
  cursor: pointer;
  color: #495057;
  font-size: 13px;
  border-bottom: 1px solid #f8f9fa;
  text-align: center;
  transition: all 0.2s ease;
}

.react-datepicker__time-list-item:hover {
  background-color: #f8f9fa;
  color: #172228;
}

.react-datepicker__time-list-item--selected {
  background-color: #172228;
  color: white;
  font-weight: 600;
}

.react-datepicker__time-list-item:last-child {
  border-bottom: none;
}

/* Melhor posicionamento */
.time-picker-popper[data-placement^="bottom"] {
  margin-top: 4px;
}

.time-picker-popper[data-placement^="top"] {
  margin-bottom: 4px;
}


@media (max-width: 768px) {
  .react-datepicker {
    transform: scale(0.9);
    margin: 0 auto;
  }

  .react-datepicker__day {
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
    font-size: 13px;
  }

  .react-datepicker__current-month {
    font-size: 16px;
  }

}

.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker-wrapper .input-group {
  flex-wrap: nowrap;
}

.react-datepicker-wrapper .input-group .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.react-datepicker-wrapper .input-group .btn-calendar {
  background-color: #172228;
  border-color: #172228;
  color: #ffffff;
  padding: 0.375rem 0.75rem;
}

.react-datepicker-wrapper .input-group .btn-calendar:hover,
.react-datepicker-wrapper .input-group .btn-calendar:focus,
.react-datepicker-wrapper .input-group .btn-calendar:active {
  background-color: #31414b;
  border-color: #31414b;
  color: #ffffff;
}

.react-datepicker-wrapper .input-group .btn-clear {
  background-color: #dc3545;
  border-color: #dc3545;
  color: #ffffff;
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
}

.react-datepicker-wrapper .input-group .btn-clear:hover {
  background-color: #bb2d3b;
  border-color: #bb2d3b;
  color: #ffffff;
}

.react-datepicker-wrapper .input-group .btn:focus {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/datepicker-custom.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;EAC5C,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;;EAGE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".react-datepicker {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);\n  font-family: inherit;\n  background: #ffffff;\n  overflow: hidden;\n  transform: scale(1);\n  transition: all 0.3s ease;\n}\n\n.react-datepicker__header {\n  background: #172228;\n  border-bottom: none;\n  border-radius: 16px 16px 0 0;\n  padding: 20px 16px 16px;\n  position: relative;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 12px;\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n\n.react-datepicker__navigation {\n  background: rgba(255, 255, 255, 0.15);\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.react-datepicker__navigation:hover {\n  background: rgba(255, 255, 255, 0.25);\n  border-color: rgba(255, 255, 255, 0.4);\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.react-datepicker__navigation--previous {\n  left: 20px;\n  top: 20px;\n}\n\n.react-datepicker__navigation--next {\n  right: 20px;\n  top: 20px;\n}\n\n.react-datepicker__navigation-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 8px;\n  height: 8px;\n}\n\n.react-datepicker__navigation-icon::before {\n  border-color: #ffffff;\n  border-width: 2px 2px 0 0;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  top: calc(50% - 1px);\n  left: calc(50% - 1px);\n  transform: translate(-50%, -50%);\n}\n\n.react-datepicker__navigation--previous .react-datepicker__navigation-icon::before {\n  transform: translate(-50%, -50%) rotate(-135deg);\n  left: calc(50% + 1px);\n}\n\n.react-datepicker__navigation--next .react-datepicker__navigation-icon::before {\n  transform: translate(-50%, -50%) rotate(45deg);\n  left: calc(50% - 1px);\n}\n\n.react-datepicker__day-names {\n  background: #172228;\n  margin: 0;\n  padding: 8px 0 0;\n}\n\n.react-datepicker__day-name {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  width: 2.5rem;\n  line-height: 1.2;\n}\n\n.react-datepicker__month {\n  margin: 0;\n  padding: 16px;\n  background: #ffffff;\n}\n\n.react-datepicker__week {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 4px;\n}\n\n.react-datepicker__day {\n  color: #495057;\n  width: 2.5rem;\n  height: 2.5rem;\n  line-height: 2.5rem;\n  margin: 2px;\n  border-radius: 50%;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  font-size: 14px;\n  position: relative;\n  border: 2px solid transparent;\n}\n\n.react-datepicker__day:hover {\n  background: #172228;\n  color: #ffffff;\n  transform: scale(1.15);\n  box-shadow: 0 8px 25px rgba(23, 34, 40, 0.3);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.react-datepicker__day--selected {\n  background: #172228;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 6px 20px rgba(23, 34, 40, 0.4);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.react-datepicker__day--today {\n  background: #d8b8a1;\n  color: #000000;\n  font-weight: 700;\n  box-shadow: 0 4px 15px rgba(216, 184, 161, 0.4);\n  border: 2px solid #fff;\n}\n\n.react-datepicker__day--today:hover {\n  background: #d8b8a1;\n  color: #000000;\n  transform: scale(1.15);\n  box-shadow: 0 8px 25px rgba(216, 184, 161, 0.5);\n}\n\n.react-datepicker__day--keyboard-selected {\n  background: transparent;\n  color: #495057;\n  border: 2px solid transparent;\n}\n\n.react-datepicker__day--keyboard-selected:hover {\n  background: #172228;\n  color: #ffffff;\n}\n\n.react-datepicker__day--outside-month {\n  color: #ced4da;\n  opacity: 0.5;\n}\n\n.react-datepicker__day--disabled {\n  color: #ced4da;\n  cursor: not-allowed;\n  opacity: 0.3;\n}\n\n.react-datepicker__day--disabled:hover {\n  background: transparent;\n  transform: none;\n  box-shadow: none;\n}\n\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 6px;\n  padding: 12px;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  color: #495057;\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  background: #172228;\n  color: #ffffff;\n  transform: scale(1.1);\n  box-shadow: 0 4px 15px rgba(23, 34, 40, 0.3);\n}\n\n.react-datepicker__month-text--selected,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__year-text--selected {\n  background: #172228;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 6px 20px rgba(23, 34, 40, 0.4);\n}\n\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background: transparent;\n  color: #495057;\n}\n\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background: #172228;\n  color: #ffffff;\n}\n\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  background: #d8b8a1;\n  color: #000000;\n  font-weight: 700;\n  box-shadow: 0 4px 15px rgba(216, 184, 161, 0.4);\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  padding: 14px;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown {\n  background: #ffffff;\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n  max-height: 280px;\n  min-width: 150px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option {\n  padding: 14px 24px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  color: #495057;\n  font-weight: 500;\n  font-size: 15px;\n  border-radius: 8px;\n  margin: 3px 8px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover {\n  background: #172228;\n  color: #ffffff;\n  transform: translateX(4px);\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected {\n  background: #172228;\n  color: #ffffff;\n  font-weight: 700;\n  box-shadow: 0 4px 12px rgba(23, 34, 40, 0.3);\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select {\n  width: auto;\n  min-width: 120px;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view {\n  padding: 10px 16px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 100px;\n  text-align: center;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow {\n  border-top-color: #ffffff;\n  margin-left: 8px;\n}\n\n.react-datepicker__month-select,\n.react-datepicker__year-select {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 16px;\n  padding: 8px 12px;\n  min-width: 100px;\n  margin: 0 4px;\n}\n\n.react-datepicker__month-select:focus,\n.react-datepicker__year-select:focus {\n  outline: none;\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.react-datepicker__month-select option,\n.react-datepicker__year-select option {\n  background: #172228;\n  color: #ffffff;\n  padding: 8px;\n}\n\n.react-datepicker__close-icon {\n  background: #172228;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: all 0.2s ease;\n  opacity: 0.8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker__close-icon:hover {\n  background: #dc3545;\n  opacity: 1;\n  transform: translateY(-50%);\n}\n\n.react-datepicker__close-icon::after {\n  content: \"×\";\n  background: transparent;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 1;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.react-datepicker {\n  animation: slideInUp 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.react-datepicker__triangle {\n  fill: #172228;\n  color: #172228;\n}\n\n/* Configurações para time picker */\n.time-picker-popper {\n  z-index: 1060 !important;\n}\n\n.time-picker-popper .react-datepicker {\n  z-index: 1060 !important;\n  border: none;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  font-family: inherit;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n/* Time picker specific styles */\n.react-datepicker--time-only {\n  width: 120px !important;\n  max-width: 120px !important;\n  min-width: 120px !important;\n}\n\n.react-datepicker--time-only .react-datepicker__header {\n  background: #172228;\n  border-bottom: none;\n  border-radius: 8px 8px 0 0;\n  padding: 12px;\n  text-align: center;\n}\n\n.react-datepicker--time-only .react-datepicker__current-month {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0;\n}\n\n.react-datepicker__time-container {\n  border: none;\n  width: 100%;\n  background: white;\n  border-radius: 0 0 8px 8px;\n}\n\n.react-datepicker__time {\n  position: relative;\n  background: white;\n  border-radius: 0 0 8px 8px;\n}\n\n.react-datepicker__time-box {\n  width: 100%;\n  overflow-x: hidden;\n  margin: 0;\n  text-align: center;\n}\n\n.react-datepicker__time-list {\n  height: 180px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  list-style: none;\n}\n\n.react-datepicker__time-list-item {\n  height: auto;\n  padding: 8px 12px;\n  white-space: nowrap;\n  cursor: pointer;\n  color: #495057;\n  font-size: 13px;\n  border-bottom: 1px solid #f8f9fa;\n  text-align: center;\n  transition: all 0.2s ease;\n}\n\n.react-datepicker__time-list-item:hover {\n  background-color: #f8f9fa;\n  color: #172228;\n}\n\n.react-datepicker__time-list-item--selected {\n  background-color: #172228;\n  color: white;\n  font-weight: 600;\n}\n\n.react-datepicker__time-list-item:last-child {\n  border-bottom: none;\n}\n\n/* Melhor posicionamento */\n.time-picker-popper[data-placement^=\"bottom\"] {\n  margin-top: 4px;\n}\n\n.time-picker-popper[data-placement^=\"top\"] {\n  margin-bottom: 4px;\n}\n\n\n@media (max-width: 768px) {\n  .react-datepicker {\n    transform: scale(0.9);\n    margin: 0 auto;\n  }\n\n  .react-datepicker__day {\n    width: 2.2rem;\n    height: 2.2rem;\n    line-height: 2.2rem;\n    font-size: 13px;\n  }\n\n  .react-datepicker__current-month {\n    font-size: 16px;\n  }\n\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker-wrapper .input-group {\n  flex-wrap: nowrap;\n}\n\n.react-datepicker-wrapper .input-group .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.react-datepicker-wrapper .input-group .btn-calendar {\n  background-color: #172228;\n  border-color: #172228;\n  color: #ffffff;\n  padding: 0.375rem 0.75rem;\n}\n\n.react-datepicker-wrapper .input-group .btn-calendar:hover,\n.react-datepicker-wrapper .input-group .btn-calendar:focus,\n.react-datepicker-wrapper .input-group .btn-calendar:active {\n  background-color: #31414b;\n  border-color: #31414b;\n  color: #ffffff;\n}\n\n.react-datepicker-wrapper .input-group .btn-clear {\n  background-color: #dc3545;\n  border-color: #dc3545;\n  color: #ffffff;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n.react-datepicker-wrapper .input-group .btn-clear:hover {\n  background-color: #bb2d3b;\n  border-color: #bb2d3b;\n  color: #ffffff;\n}\n\n.react-datepicker-wrapper .input-group .btn:focus {\n  box-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
